export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 90,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displayLogo') || '客户LOGO',
    field: 'displayLogo',
    width: 110,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayLogo' },
  },
  {
    title: that.$l('table_label_displayCustomer') || '客户名称',
    field: 'displayCustomer',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCustomer' },
  },
  {
    title: that.$l('table_label_displayDepartment') || '费用部门',
    field: 'displayDepartment',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayDepartment' },
  },
  {
    title: that.$l('table_label_displayOrganization') || '机构名称',
    field: 'displayOrganization',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayOrganization' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
